import { gql } from '@apollo/client';

export const GET_COUNTRIES = gql`
    query Countries ($language: String!, $skip: Int!, $take: Int!) {
        countries(language: $language, skip: $skip, take: $take) {
            id
            description: name
            iso
            iso3
            isoNum
        }
    }`;

export const GET_COVERAGES = gql`
    query Benefits($language: String) {
        benefits(language: $language) {
            code: benefitCode
            description
            options {
                code: optionCode
                description: value
                type
            }
        }
    }`

export const GET_OPTIONS_BY_BENEFIT_CODE = gql`
    query GetBenefitByCode($benefitCode: String, $language: String) {
        getBenefitByCode(benefitCode: $benefitCode, language: $language) {
            code:benefitCode
            description
            options {
            code: optionCode
            description: value
            type
            }
        }
    }`

export const GET_COUNTRY_WITH_CHANGE_DEDUCTIBLE_LIST = gql`
    query GetCountriesWithChangeDeductible {
        countriesWithDeductibleByCountryOfResidence {
            isoNum
        }
    }`;

export const GET_DEDUCTIBLE_OPTIONS = gql`
    query GetCountryConfig($isoNumber: String) {
      getCountryDeductibleConfig(isoNumber: $isoNumber) {
        isoNumber
        country
        geographicalCoverage {
          coverageCode
          order
          primary {
            options {
              code
              value
            }
            combinations {
              code
              value
            }
          }
        }
      }
    }`
